import { Col, Row, Td, Tr } from "@visa/vds";
import { useAuthContextUser } from "context/AuthContext";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import { useContext, useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { DashboardStaffApi, DashboardUserApi } from "services/dashboard.service";
import React from "react";
import MCSPagedTable from "components/MCSPagedTable";
import { CERTIFICATION_PACKAGE_TITLE, DASHBOARD_CERTIFICATION_PACKAGE_TABLE_HEADERS } from "_constants/DashboardConstants";
import { DateHelper } from "_helpers/DateHelper";
import CertificationPackageTableAction from "./CertificationPackagesTableAction";
import CertificationPackagesAccordionActionItems from "./CertificationPackagesActionItems";
import CertificationPackageDashboardAccordion from "./CertificationPackageDashboardAccordion";
import CertificationPackageState from "pages/CertificationWorkflow/SharedComponents/CertificationPackageState";
import NewCertificationPackage from "pages/CertificationWorkflow/CertificationPackage/NewCertificationPackage";
import CertificationPackageWarningDialog from "./CertificationPackageWarningDialouge";

const CertificationPackagesAccordion = (props) => {
    let {
        selectedBid,
        setPageError,
    } = props

    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();

    const isExternalUser = user && user.isExternalUser;
    const API = isExternalUser ? DashboardUserApi : DashboardStaffApi

    const [certificationPackages, setCertificationPackages] = useState(null);
    const [sortBy, setSortBy] = useState("lastUpdatedOn");
    const [totalCount, setTotalCount] = useState(4);
    const [desc, setDesc] = useState(true);
    const [vstsAccessStatusDescription, setVstsAccessStatusDescription] = useState("");
    const [hasVstsAccess, setHasVstsAccess] = useState();
    const [vstsAccessStatusDescriptionNo, setVstsAccessStatusDescriptionNo] = useState(null);
    const PAGE_SIZE = 6;
    const totalPage = 1;
    const tableHeaders = DASHBOARD_CERTIFICATION_PACKAGE_TABLE_HEADERS;
    const [openPackageWarningDialog, setOpenSubscriptionWarningDialog] = useState(false)
    const [openNewCertificationPopup, setOpenNewCertificationPopup] = useState(false);


    const setComponentState = (result) => {
        setCertificationPackages(result.data.certificationPackages)
        setTotalCount(result.data.certificationPackages.length)

        setVstsAccessStatusDescription(result.data.vstsAccessStatus.vstsAccessDescriptionText)
        setHasVstsAccess(result.data.vstsAccessStatus.vstsAccess)
        setVstsAccessStatusDescriptionNo(result.data.vstsAccessStatus.vstsAccessDescription)
    }

    const fetchData = (sortBy, desc) => {
        trackPromise(
            API.getActiveCertificationPackages(selectedBid, sortBy, desc)
                .then((result) => {
                    setComponentState(result)
                })
                .catch((error) => {
                    setPageError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    }

    const handleSortChange = async (sortBy = null, desc = false) => {
        fetchData(sortBy, desc)
    }

    useEffect(() => {
        fetchData(sortBy, desc)
    }, [selectedBid])

    return (
        <Row>
            <Col>
                <CertificationPackageDashboardAccordion id="dashboard-certification-package-accordion"
                    vstsAccess={hasVstsAccess}
                    vstsAccessDescription={vstsAccessStatusDescription}
                    vstsAccessBtn={hasVstsAccess}
                    title={CERTIFICATION_PACKAGE_TITLE}
                    totalCount={totalCount}
                    accordionHeaderActionComponent={
                        <CertificationPackagesAccordionActionItems
                        openPackageWarningDialog={openPackageWarningDialog}
                        setOpenSubscriptionWarningDialog={setOpenSubscriptionWarningDialog}
                        openNewCertificationPopup={openNewCertificationPopup}
                        setOpenNewCertificationPopup={setOpenNewCertificationPopup}
                        totalCount={totalCount}
                        vstsAccess={hasVstsAccess}
                        />}
                    isExternalUser={isExternalUser}
                    vstsAccessStatusDescriptionNo={vstsAccessStatusDescriptionNo}
                >
                    <Row className="approved-products-table">
                        <NewCertificationPackage open={openNewCertificationPopup} setOpen={setOpenNewCertificationPopup} />
                        <CertificationPackageWarningDialog
                            openPackageWarningDialog={openPackageWarningDialog}
                            setOpenPackageWarningDialog={setOpenSubscriptionWarningDialog}
                        />
                        <MCSPagedTable
                            size={"compact"}
                            colHeaders={tableHeaders}
                            selectedPage={1}
                            ordered={sortBy}
                            setOrdered={setSortBy}
                            sortData={handleSortChange}
                            isDsc={desc}
                            setDsc={setDesc}
                            totalPages={totalPage}
                            pageSize={PAGE_SIZE}
                            totalCount={totalCount}
                            usePagination={true}
                            tableData={
                                certificationPackages && certificationPackages.map((row, key) => {
                                    return (
                                        <Tr className="row-vstt-even" key={key}>
                                            <Td id={"packageId_" + key}>{row.id}</Td>
                                            <Td id={"packageName_" + key}>{row.packageName}</Td>
                                            <Td id={"implementationType_" + key}>{row.implementationType}</Td>
                                            <Td id={"packageCreatedOn_" + key}>{DateHelper.ToFormattedDate(row.createdOn)}</Td>
                                            <Td id={"packageUpdatedOn_" + key}>{DateHelper.ToFormattedDate(row.lastUpdatedOn)}</Td>
                                            <Td id={"packageState_" + key} style={{ "display": "flex", "paddingTop": "12px", "flexDirection": "column", "justifyContent": "center" }}>
                                                <CertificationPackageState
                                                    packageState={row.packageState}
                                                />
                                            </Td>
                                            <Td id={"packageAction_" + key}>
                                                <CertificationPackageTableAction
                                                    packageState={row.packageState}
                                                    user={user}
                                                    packageId={row.id}
                                                    currentSubscription={null}
                                                />
                                            </Td>
                                        </Tr>
                                    )
                                })
                            }
                        />
                    </Row>
                </CertificationPackageDashboardAccordion>
            </Col>
        </Row>
    );
}

export default CertificationPackagesAccordion;

